import $ from "jquery";

$(document).ready(() => {
    const contentAreaSelector = ".floatable-area .content-area";
    $(".floatable-area #icon-area").click((e) => {
        const contentAreaElem = $(e.target).closest(".floatable-area").find(".content-area");
        if (contentAreaElem.is(":visible")) {
            $(contentAreaElem).attr("hidden", "").attr("aria-hidden", true).hide(450);
        } else {
            $(contentAreaElem).removeAttr("hidden").attr("aria-hidden", false).show(450);
        }
    });
    $(document).click((e) => {
        const clickedClassName = e.target.className;
        if (clickedClassName !== "content-area" && clickedClassName.indexOf("floatable-icon") < 0 ) {
            $(contentAreaSelector).attr("hidden", "").attr("aria-hidden", true).hide(450);
        }
    });
});
